export default __webpack_public_path__ + "static/media/WFHAM-dark.cc0abd61.svg";